var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyTaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20703 9.8L7.20703 10.8L9.8737 8.13333",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 3.99999H9.33301C10.6663 3.99999 10.6663 3.33333 10.6663 2.66666C10.6663 1.33333 9.99967 1.33333 9.33301 1.33333H6.66634C5.99967 1.33333 5.33301 1.33333 5.33301 2.66666C5.33301 3.99999 5.99967 3.99999 6.66634 3.99999Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.67999C12.8867 2.79999 14 3.61999 14 6.66666V10.6667C14 13.3333 13.3333 14.6667 10 14.6667H6C2.66667 14.6667 2 13.3333 2 10.6667V6.66666C2 3.62666 3.11333 2.79999 5.33333 2.67999",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTaskIcon);
export default __webpack_public_path__ + "static/media/my-task-icon.0bb36f23ef397a3e436c82434e2c35b3.svg";
export { ForwardRef as ReactComponent };